module.exports = __webpack_public_path__ + "img/placeholder.4c5b6cb2.jpg";